import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';

const RitualCarousel = () => {
  const [items, setItems] = useState([]);
  const trackRef = useRef(null);
  const animRef  = useRef(null);
  const offsetRef = useRef(0);
  const speedRef  = useRef(0.5);

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const r = await api.get('/ritual-carousel');
      setItems(r.data);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (items.length === 0) return;

    const track = trackRef.current;
    if (!track) return;

    const animate = () => {
      offsetRef.current += speedRef.current;

      const CARD_W = 236;
      const totalW = items.length * CARD_W;

      if (offsetRef.current >= totalW) {
        offsetRef.current -= totalW;
      }

      track.style.transform = `translateX(-${offsetRef.current}px)`;
      animRef.current = requestAnimationFrame(animate);
    };

    animRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animRef.current);
  }, [items]);

  const pause = () => { speedRef.current = 0; };
  const resume = () => { speedRef.current = 0.5; };

  if (items.length === 0) return null;

  const looped = [...items, ...items, ...items];

  return (
    <section className="py-16 md:py-24 bg-white overflow-hidden" data-testid="ritual-carousel-section">
      <div className="container mx-auto px-4 md:px-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-[#2A0000] text-center mb-12 tracking-[0.3em] uppercase">
          A LOOK FOR EVERY RITUAL
        </h2>
      </div>

      <div
        className="relative"
        style={{ height: 500 }}
        onMouseEnter={pause}
        onMouseLeave={resume}
      >
        <div
          ref={trackRef}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 16,
            willChange: 'transform',
            paddingLeft: 16,
            width: 'max-content',
          }}
        >
          {looped.map((item, idx) => {
            const isDown = idx % 2 === 1;
            return (
              <div
                key={idx}
                data-testid={`ritual-item-${idx}`}
                style={{
                  flexShrink: 0,
                  width: 220,
                  height: isDown ? 380 : 420,
                  marginTop: isDown ? 60 : 0,
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'block',
                  cursor: 'default',
                }}
              >
                <img
                  src={item.image}
                  alt={item.label}
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'top center',
                  }}
                />
                <div style={{
                  position: 'absolute', inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.05) 50%, transparent 80%)',
                }} />
                <div style={{ position: 'absolute', bottom: 14, left: 0, right: 0, textAlign: 'center' }}>
                  <p style={{
                    color: '#fff',
                    fontSize: '0.7rem',
                    letterSpacing: '0.2em',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    textShadow: '0 1px 6px rgba(0,0,0,0.7)',
                  }}>
                    {item.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RitualCarousel;